import classNames from 'classnames'
import { forwardRef, HTMLAttributes } from 'react'

import { BodyText } from '../body-text/body-text'
import { Slot } from '../utilities'
import styles from './chat-message.module.scss'
import { useChatMessageContext } from './context'

export type ChatMessageContentElement = HTMLDivElement
export type ChatMessageContentProps = HTMLAttributes<ChatMessageContentElement> & {
  asChild?: boolean
}

export const ChatMessageContent = forwardRef<ChatMessageContentElement, ChatMessageContentProps>(
  function ChatMessageContent(props, forwardedRef) {
    const { className, asChild, ...rest } = props
    const { size } = useChatMessageContext()
    const classes = classNames(styles.content, className)
    const Component = asChild ? Slot : 'div'
    return (
      <BodyText size={size} asChild>
        <Component {...rest} className={classes} ref={forwardedRef} />
      </BodyText>
    )
  }
)
